import React from 'react';
import { directionMap, GenericIconProps } from './utils';
import theme from '../utils/theme/theme';

export default function IconArrow(props: GenericIconProps) {
  const {
    scale = 1,
    width = scale * 11,
    height = scale * 12,
    stroke = theme.colors.black,
    direction = 'left',
  } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 12"
      version="1.1"
      style={{ transform: `rotate(${directionMap[direction]}deg)` }}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-271.000000, -2015.000000)"
          stroke={stroke}
          strokeWidth="2"
        >
          <g transform="translate(270.000000, 2009.000000)">
            <g transform="translate(-5.000000, 0.000000)">
              <path d="M16.6666667,12 L7.33333333,12" />
              <polyline points="12 16.6666667 7.33333333 12 12 7.33333333" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
